export default {
  test: 'en',
  device: 'Device',
  personal: 'Personal Information',
  describeLocation: 'Please describe the fault location',
  ClickDescription: 'Click the icon to add a description',
  voice: 'Voice',
  video: 'Video',
  text: 'Text',
  clickAttachment: 'Click uploading attachment',
  uploadFiles: 'Upload Files',
  Supports: 'Supports extension:.rar.zip.doc.docx.pdf.jpg...',
  PreviewInformation: 'Preview the repair information',
  PleaseContent: 'Please enter content',
  submit: 'Submit',
  leaveMessage: 'Leave a message',
  SN: 'Equipment of SN',
  productLine: 'Product line',
  productModel: 'Product Model',
  hospital: 'The hospital',
  address: 'The Address',
  department: 'The Department',
  position: 'The Position',
  name: 'The Name',
  contactWay: 'Contact Way',
  startRecording: 'Start The Recording',
  stopRecording: 'Stop The Recording',
  equipment: 'The Repair Equipment',
  describe: 'Describe',
  confirmRepair: 'Confirm and submit for repair',
  repairTime: 'The Repair Time',
  submitRepair: 'Submit The Repair',
  repairReport: 'Are you sure to submit this repair report??',
  OnceSubmitted: 'Once submitted, professional personnel will come to repair',
  score: 'Score',
  notScored: 'The following are open questions, not scored',
  productsServices: 'Do you have any other comments and suggestions on Neusoft products and services',
  suggestions: 'Please input your comments and suggestions',
  maintenanceState: 'maintenance state ',
  chooseYear: 'Choose the year',
  search: 'Search',
  maintenanceMan: 'Maintenance Man',
  ViewDetailed: 'View Detailed',
  repairService: 'A key repair service',
  repairSchedule: 'Repair Schedule',
  MaintenanceRecord: 'Maintenance History Record',
  MaintenanceEvaluation: 'Maintenance Evaluation',
  service: 'Service',
  quickLogin: 'Quick login with mobile phone number',
  verificationCode: 'Verification Code',
  gain: 'Gain',
  login: 'Login Immediately',
  cellPhone: 'Cell-phone Number',
  signUp: 'Sign up right away ',
  enterNumber: 'Please enter your mobile phone number',
  ResponsibleEquipment: 'Responsible for equipment',
  selectionTime: 'Selection time',
  remainEvaluated: 'Remain to be evaluated ',
  serialNumber: 'Serial number',
  compile: 'Compile',
  addEquipments: 'Add equipments',
  save: 'Save ',
  modifySuccessfully: 'Modify successfully',
  logOut: 'Log Out',
  picture: 'Picture'

}
